import { useEffect, useState } from "react"
import { GetDocument } from "../../../firebase/firebase"

export const EditBlogWrapper = (props) => {
    const blogId = props.blog
    const [blog, setBlog] = useState('')

    useEffect(() => {
        GetDocument('blogPosts', blogId).then((data)=>{
            setBlog(data.data())
        })
    }, [])
    
    return (
        <>
            {blog.title}
        </>
    )
}